import reviewsSummaryStore from 'store/reviews-summary-store'

export function schemaOrgEntityType(schemaOrgEntityType) {
  if (schemaOrgEntityType) {
    reviewsSummaryStore.schemaOrgEntityType = schemaOrgEntityType
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/reviews-summary/reviews-summary-commands.ts